<template>
  <el-image style="width: 100px; height: 100px" :src="getUrl(statue)" />
</template>

<script >
export default {
  name: 'StatueIcon',
  props: {
    statue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      statueMap: {
        '0': {
          desc: '圆形',
          imgUrl: require('@/view/d2/conponents/statue-icon/static/yuanxing.png')
        },
        '3': {
          desc: '三角形',
          imgUrl: require('@/view/d2/conponents/statue-icon/static/sanjiaoxing.png')
        },
        '4': {
          desc: '正方形',
          imgUrl: require('@/view/d2/conponents/statue-icon/static/zhengfangxing.png')
        },
        '00': {
          desc: '球体',
          imgUrl: require('@/view/d2/conponents/statue-icon/static/qiuti.png')
        },
        '33': {
          desc: '三棱锥',
          imgUrl: require('@/view/d2/conponents/statue-icon/static/sanlengzhui.png')
        },
        '44': {
          desc: '正方体',
          imgUrl: require('@/view/d2/conponents/statue-icon/static/zhengfangti.png')
        },
        '03': {
          desc: '圆锥体',
          imgUrl: require('@/view/d2/conponents/statue-icon/static/yuanzhuiti.png')
        },
        '04': {
          desc: '圆柱体',
          imgUrl: require('@/view/d2/conponents/statue-icon/static/yuanzhuti.png')
        },
        '34': {
          desc: '三棱柱',
          imgUrl: require('@/view/d2/conponents/statue-icon/static/sanlengzhu.png')
        }
      }
    }
  },
  methods: {
    getUrl(statue) {
      return this.statueMap[statue]?.imgUrl
    }
  }
}
</script>
<style scoped lang="scss">

</style>
